import script from "./ui-modal-confirm.vue?vue&type=script&setup=true&lang=js"
export * from "./ui-modal-confirm.vue?vue&type=script&setup=true&lang=js"

import "./ui-modal-confirm.vue?vue&type=style&index=0&id=0a2352d9&lang=scss"

const __exports__ = script;

export default __exports__